<label class="switch">
  <input class="form-check-input"
         type="checkbox"
         [ngModel]="model"
         (ngModelChange)="onModelChange($event)"
         (change)="switchChangeEvent(model)"
         [name]="name"
         [attr.disabled]="disabled">
  <span class="slider round"></span>
</label>



// WEBPACK FOOTER //
// ./src/app/core/achoo-toggle-switch/achoo-toggle-switch.component.html